import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

const Ban = () => <FontAwesomeIcon height="16px" iconName="ban" />;
const CircleExclamation = () => (
  <FontAwesomeIcon height="16px" iconName="circle-exclamation" />
);
const CopyLink = () => <FontAwesomeIcon height="16px" iconName="copy" />;
const Delete = () => <FontAwesomeIcon height="16px" iconName="trash-can" />;
const Edit = () => <FontAwesomeIcon height="16px" iconName="pen" />;

export const actionItemsIcons = {
  ban: Ban,
  circleExclamation: CircleExclamation,
  copyLink: CopyLink,
  delete: Delete,
  edit: Edit,
};
